import Vue from 'vue'

// Generate unique IDs for elements
let elementIdCounter = 0
const generateElementId = () => `ai-translate-${++elementIdCounter}`

// Store references to created elements and their cleanup functions
const elementRegistry = new Map()

Vue.directive('ai-translate', {
	bind (el, binding, vnode) {
		// Skip if element is not an input or textarea
		if (!['INPUT', 'TEXTAREA'].includes(el.tagName)) {
			console.warn('v-ai-translate directive can only be used on input and textarea elements')
			return
		}

		// Generate unique ID for this element
		const elementId = generateElementId()
		el.setAttribute('data-ai-translate-id', elementId)

		// Get configuration from binding value
		const config = {
			sourceLanguage: 'en',
			phrase: '',
			targetLanguage: 'en',
			context: null,
			onTranslated: null,
			onError: null,
			position: 'inside-right', // 'right', 'left', 'inside-right', 'inside-left'
			iconClass: 'fa fa-magic',
			tooltip: 'AI Translate',
			disabled: false,
			...binding.value
		}

		// Create the AI translate button
		const aiButton = createAiButton(config, elementId)

		// Position the button relative to the input
		// positionButton(el, aiButton, config.position)
		positionClassButton(el, aiButton, config.position)

		// Store cleanup function
		const cleanup = () => {
			if (aiButton && aiButton.parentNode) {
				aiButton.parentNode.removeChild(aiButton)
			}
		}

		elementRegistry.set(elementId, {
			element: el,
			button: aiButton,
			config,
			cleanup
		})

		// Handle click events
		const handleClick = async (event) => {
			event.preventDefault()
			event.stopPropagation()

			const store = vnode.context.$store
			const inputValue = config.phrase // el.value.trim()
			event.target.classList.add('aiing')
			setTimeout(() => event.target.classList.remove('aiing'), 500)
			// event.target.parentElement.classList.add('border-ai')

			if (!inputValue) {
				store.commit('toast/_addError', 'Please enter some text to translate', { root: true })
				return
			}

			if (!config.targetLanguage) {
				store.commit('toast/_addError', 'Target language not specified', { root: true })
				return
			}

			try {
				// Update button state to loading
				updateButtonState(aiButton, 'loading')

				// Perform translation
				const translatedText = await store.dispatch('AITranslations/translateText', {
					text: config.phrase,
					sourceLanguage: config.sourceLanguage,
					targetLanguage: config.targetLanguage,
					elementId: elementId,
					context: config.context
				})

				// Update input value
				el.value = translatedText

				// Trigger input event to update v-model
				const inputEvent = new Event('input', { bubbles: true })
				el.dispatchEvent(inputEvent)

				// Call onTranslated callback if provided
				if (typeof config.onTranslated === 'function') {
					config.onTranslated(translatedText, inputValue)
				}

				// Update button state to success
				updateButtonState(aiButton, 'success')
				setTimeout(() => {
					updateButtonState(aiButton, 'default')
					// event.target.parentElement.classList.remove('border-ai')
				}, 2000)
			} catch (error) {
				console.error('Translation error:', error)

				// Call onError callback if provided
				if (typeof config.onError === 'function') {
					config.onError(error.message)
				}

				// Update button state to error
				updateButtonState(aiButton, 'error')
				setTimeout(() => updateButtonState(aiButton, 'default'), 3000)
			}
		}

		// Add click event listener
		aiButton.addEventListener('click', handleClick)

		// Handle keyboard accessibility
		const handleKeydown = (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				handleClick(event)
			}
		}

		aiButton.addEventListener('keydown', handleKeydown)

		// Store event handlers for cleanup
		elementRegistry.get(elementId).handleClick = handleClick
		elementRegistry.get(elementId).handleKeydown = handleKeydown
	},

	update (el, binding) {
		const elementId = el.getAttribute('data-ai-translate-id')
		const registry = elementRegistry.get(elementId)

		if (registry && binding.value !== binding.oldValue) {
			// Update configuration
			registry.config = {
				...registry.config,
				...binding.value
			}

			// Update button properties
			updateButtonConfig(registry.button, registry.config)
		}
	},

	unbind (el) {
		const elementId = el.getAttribute('data-ai-translate-id')
		const registry = elementRegistry.get(elementId)

		if (registry) {
			// Remove event listeners
			if (registry.handleClick) {
				registry.button.removeEventListener('click', registry.handleClick)
			}
			if (registry.handleKeydown) {
				registry.button.removeEventListener('keydown', registry.handleKeydown)
			}

			// Cleanup DOM elements
			registry.cleanup()

			// Remove from registry
			elementRegistry.delete(elementId)
		}
	}
})

// Helper function to create the AI button
function createAiButton (config, elementId) {
	const button = document.createElement('button')
	button.type = 'button'
	button.className = `ai-translate-btn ${config.disabled ? 'disabled' : ''}`
	button.setAttribute('data-element-id', elementId)
	button.setAttribute('title', config.tooltip)
	button.setAttribute('tabindex', '0')
	button.setAttribute('aria-label', config.tooltip)

	// Create icon
	const icon = document.createElement('i')
	icon.className = config.iconClass
	button.appendChild(icon)

	// Add to DOM
	// document.body.appendChild(button)
	// console.log(elementId)
	setTimeout(() => {
		document.querySelector(`input[data-ai-translate-id="${elementId}"]`).parentElement.appendChild(button)
	}, 100)

	return button
}

function positionClassButton (inputEl, button, position) {
	button.classList.add(position)
}
// Helper function to position the button
// function positionButton (inputEl, button, position) {
// 	const rect = inputEl.getBoundingClientRect()
// 	const scrollTop = window.pageYOffset || document.documentElement.scrollTop
// 	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

// 	button.style.position = 'absolute'
// 	button.style.zIndex = '1000'

// 	switch (position) {
// 	case 'right':
// 		button.style.left = `${rect.right + scrollLeft + 5}px`
// 		button.style.top = `${rect.top + scrollTop + (rect.height - 30) / 2}px`
// 		break
// 	case 'left':
// 		button.style.left = `${rect.left + scrollLeft - 35}px`
// 		button.style.top = `${rect.top + scrollTop + (rect.height - 30) / 2}px`
// 		break
// 	case 'inside-right':
// 		button.style.left = `${rect.right + scrollLeft - 35}px`
// 		button.style.top = `${rect.top + scrollTop + (rect.height - 30) / 2}px`
// 		break
// 	case 'inside-left':
// 		button.style.left = `${rect.left + scrollLeft + 5}px`
// 		button.style.top = `${rect.top + scrollTop + (rect.height - 30) / 2}px`
// 		break
// 	default:
// 		button.style.left = `${rect.right + scrollLeft + 5}px`
// 		button.style.top = `${rect.top + scrollTop + (rect.height - 30) / 2}px`
// 	}

// 	// Update position on window resize and scroll
// 	const updatePosition = () => positionButton(inputEl, button, position)
// 	window.addEventListener('resize', updatePosition)
// 	window.addEventListener('scroll', updatePosition)

// 	// Store cleanup for position listeners
// 	button._positionCleanup = () => {
// 		window.removeEventListener('resize', updatePosition)
// 		window.removeEventListener('scroll', updatePosition)
// 	}
// }

// Helper function to update button state
function updateButtonState (button, state) {
	const icon = button.querySelector('i')

	// Remove all state classes
	button.classList.remove('loading', 'success', 'error')

	switch (state) {
	case 'loading':
		button.classList.add('loading')
		icon.className = 'fa fa-spinner fa-spin'
		button.disabled = true
		break
	case 'success':
		button.classList.add('success')
		icon.className = 'fa fa-check'
		button.disabled = false
		break
	case 'error':
		button.classList.add('error')
		icon.className = 'fa fa-exclamation-triangle'
		button.disabled = false
		break
	default:
		icon.className = button.getAttribute('data-original-icon') || 'fa fa-magic'
		button.disabled = false
	}
}

// Helper function to update button configuration
function updateButtonConfig (button, config) {
	button.setAttribute('title', config.tooltip)
	button.setAttribute('aria-label', config.tooltip)

	if (config.disabled) {
		button.classList.add('disabled')
		button.disabled = true
	} else {
		button.classList.remove('disabled')
		button.disabled = false
	}
}

export default {
	// Export for manual registration if needed
	install (Vue) {
		// Directive is already registered above
	}
}
